import view from "../../views/leaderboard";
import KTAPI, { getAllPlayers } from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler } from "../classes/index.classes";

var loading = false;
var tempdata = {};

let players = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {  

        if(data.tab == null) data.tab = 'kills';
        
        if(data.rerender == true)
        {

        }
        tempdata = data;
        
       

        if(data.tab == 'maps' || data.tab == 'weapons') 
        {
            $(`.leaderboard-tab[tab="empty"]`).tab('show');

            
        }
        $(`.leaderboard-tab[tab="${data.tab}"]`).tab('show');
                

        console.log(data);

        checkWidth();
                
        KTScroll.init();

        

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};

$(document).ready(function(){    
    $(document).on("shown.bs.tab", "a.leaderboard-tab[data-bs-toggle=tab]", function (e) {
        //console.log($(this).attr("href"));
        renderTab($(this).attr("tab"), tempdata);
    });
    $(document).on("shown.bs.tab", "a.leaderboard-subtab[data-bs-toggle=tab]", function (e) {
        //renderTab(tempdata.tab, {subtab: $(this).attr("tab")});
    });

    $(window).scroll(async function() {
        if(router.getCurrentLocation().url.includes("leaderboard"))
        {
            if(router.getCurrentLocation().url.includes("kills"))
            {
                console.log("kills");
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    console.log("calling next page");
                    let res = await KTAPI.getLeaderboard({item: "kills", paged: true, page:$(".table-leaders-kills-body").data("players-next-page"), limit:25});
                    $(".table-leaders-kills-body").data("players-page",res.page);
                    $(".table-leaders-kills-body").data("players-has-next",res.hasNextPage);

                    $(".table-leaders-kills-body").data("players-next-page",res.nextPage);
                    renderKillsTable(res);
                    loading = false;
                    //$("#player-list-loader").addClass("d-none");
                }
            }
            
            if(router.getCurrentLocation().url.includes("aim"))
            {
                console.log("aim");
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    console.log("calling next page");
                    let res = await KTAPI.getLeaderboard({item: "aim", paged: true, page:$(".table-leaders-aim-body").data("players-next-page"), limit:25});
                    $(".table-leaders-aim-body").data("players-page",res.page);
                    $(".table-leaders-aim-body").data("players-has-next",res.hasNextPage);
                    $(".table-leaders-aim-body").data("players-next-page",res.nextPage);
                    renderAimTable(res);
                    loading = false;
                    //$("#player-list-loader").addClass("d-none");
                }
            }
            if(router.getCurrentLocation().url.includes("multikills"))
            {
                console.log("multikills");
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    console.log("calling next page");
                    let res = await KTAPI.getLeaderboard({item: "multikills", paged: true, page:$(".table-leaders-multikills-body").data("players-next-page"), limit:25});
                    $(".table-leaders-multikills-body").data("players-page",res.page);
                    $(".table-leaders-multikills-body").data("players-has-next",res.hasNextPage);
                    $(".table-leaders-multikills-body").data("players-next-page",res.nextPage);
                    rendermultikillsTable(res);
                    loading = false;
                    //$("#player-list-loader").addClass("d-none");
                }
            }
            if(router.getCurrentLocation().url.includes("clutches"))
            {
                console.log("clutches");
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    console.log("calling next page");
                    let res = await KTAPI.getLeaderboard({item: "clutches", paged: true, page:$(".table-leaders-clutches-body").data("players-next-page"), limit:25});
                    $(".table-leaders-clutches-body").data("players-page",res.page);
                    $(".table-leaders-clutches-body").data("players-has-next",res.hasNextPage);
                    $(".table-leaders-clutches-body").data("players-next-page",res.nextPage);
                    renderClutchesTable(res);
                    loading = false;
                    //$("#player-list-loader").addClass("d-none");
                }
            }
            if(router.getCurrentLocation().url.includes("bombs"))
            {
                console.log("bombs");
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                    loading = true;
                    console.log("calling next page");
                    let res = await KTAPI.getLeaderboard({item: "bombs", paged: true, page:$(".table-leaders-bombs-body").data("players-next-page"), limit:25});
                    $(".table-leaders-bombs-body").data("players-page",res.page);
                    $(".table-leaders-bombs-body").data("players-has-next",res.hasNextPage);
                    $(".table-leaders-bombs-body").data("players-next-page",res.nextPage);
                    renderBombsTable(res);
                    loading = false;
                    //$("#player-list-loader").addClass("d-none");
                }
            }
            if(router.getCurrentLocation().url.includes("maps"))
            {
                if(tempdata.subtab !== undefined && tempdata.subtab !== null && tempdata.subtab !== '')
                {
                    console.log("maps");
                    if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                        loading = true;
                        console.log("calling next page");
                        let res = await KTAPI.getLeaderboard({item: "maps", subitem: tempdata.subtab, paged: true, page:$(".table-leaders-maps-body").data("players-next-page"), limit:25});
                        $(".table-leaders-maps-body").data("players-page",res.page);
                        $(".table-leaders-maps-body").data("players-has-next",res.hasNextPage);
                        $(".table-leaders-maps-body").data("players-next-page",res.nextPage);
                        renderMapLeaderTable(res);
                        loading = false;
                        //$("#player-list-loader").addClass("d-none");
                    }
                }
            }

            if(router.getCurrentLocation().url.includes("weapons"))
            {
                if(tempdata.subtab !== undefined && tempdata.subtab !== null && tempdata.subtab !== '')
                {
                    console.log("weapons");
                    if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && !loading) {
                        loading = true;
                        console.log("calling next page");
                        let res = await KTAPI.getLeaderboard({item: "weapons", subitem: tempdata.subtab, paged: true, page:$(".table-leaders-weapons-body").data("players-next-page"), limit:25});
                        $(".table-leaders-weapons-body").data("players-page",res.page);
                        $(".table-leaders-weapons-body").data("players-has-next",res.hasNextPage);
                        $(".table-leaders-weapons-body").data("players-next-page",res.nextPage);
                        renderWeaponLeaderTable(res);
                        loading = false;
                        //$("#player-list-loader").addClass("d-none");
                    }                   
                }
            }
        }
    });

    $(document).on("click", function(e){
        //console.log(e.target);
    });
    
    // Ejecuta checkWidth al cargar la página y al cambiar el tamaño de la ventana
    $(document).on("click", '.leaderboard-tab', function (e) {
        console.log("click .nav-item.nav-item-leaders a");
        e.preventDefault();
        $('.leaderboard-tab').removeClass('active');
        $(this).tab('show');
    });

    $(document).on("show.bs.tab", "a.leaderboard-tab[data-bs-toggle=tab]", function (e) {
        $("a.leaderboard-tab[data-bs-toggle=tab]").not(`[tab=${$(this).attr("tab")}]`).removeClass('active');
    });

    $(window).resize(checkWidth);
});

function checkWidth() {
    var windowWidth = $(window).width();
    // Si el ancho de la pantalla es menor que xl
    if (windowWidth < 1200) {
        // Inicializa Slick Carousel
        $('.leaders-tab-carousel').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 1,
            //slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev btn btn-icon btn-light btn-active-light-primary position-absolute w-35px h-35px z-index-1" style="top: 14px;left: -18px;"><i class="bi bi-chevron-compact-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-icon btn-light btn-active-light-primary position-absolute w-35px h-35px z-index-1" style="top: 14px;right: -18px;"><i class="bi bi-chevron-compact-right"></i></button>',
        });
    } else {
        // Si el ancho de la pantalla es igual o mayor que xl, destruye Slick Carousel si existe
        if ($('.leaders-tab-carousel').hasClass('slick-initialized')) {
            $('.leaders-tab-carousel').slick('unslick');
        }
    }
}

const renderTab = async (tab, data) => {
    if(tab == 'kills')
    {
        $(".table-leaders-kills-body").data("players-page",1);
        let page = 1;
        loading = true;
        
        let res = await KTAPI.getLeaderboard({item: tab, paged: true, page, limit: 25, steamid: _user.me.steamid});
        $(".table-leaders-kills-body").data("players-total-results",res.totalDocs || 0);
        $(".table-leaders-kills-body").data("players-total-pages",res.totalPages || 0);
        $(".table-leaders-kills-body").data("players-has-next",res.hasNextPage || 0);
        $(".table-leaders-kills-body").data("players-next-page",res.nextPage || 0);
        
        renderKillsTable(res);
        loading = false;
    }
    if(tab == 'aim')
    {
        $(".table-leaders-aim-body").data("players-page",1);
        let page = 1;
        loading = true;
        
        let res = await KTAPI.getLeaderboard({item: tab, paged: true, page, limit: 25});
        $(".table-leaders-aim-body").data("players-total-results",res.totalDocs || 0);
        $(".table-leaders-aim-body").data("players-total-pages",res.totalPages || 0);
        $(".table-leaders-aim-body").data("players-has-next",res.hasNextPage || 0);
        $(".table-leaders-aim-body").data("players-next-page",res.nextPage || 0);
        
        renderAimTable(res);
        loading = false;
        
    }
    if(tab == 'multikills')
    {
        $(".table-leaders-multikills-body").data("players-page",1);
        let page = 1;
        loading = true;
        
        let res = await KTAPI.getLeaderboard({item: tab, paged: true, page, limit: 25});
        $(".table-leaders-multikills-body").data("players-total-results",res.totalDocs || 0);
        $(".table-leaders-multikills-body").data("players-total-pages",res.totalPages || 0);
        $(".table-leaders-multikills-body").data("players-has-next",res.hasNextPage || 0);
        $(".table-leaders-multikills-body").data("players-next-page",res.nextPage || 0);
        
        rendermultikillsTable(res);
        loading = false;
    }
    if(tab == 'clutches')
    {
        $(".table-leaders-clutches-body").data("players-page",1);
        let page = 1;
        loading = true;
        
        let res = await KTAPI.getLeaderboard({item: tab, paged: true, page, limit: 25});
        $(".table-leaders-clutches-body").data("players-total-results",res.totalDocs || 0);
        $(".table-leaders-clutches-body").data("players-total-pages",res.totalPages || 0);
        $(".table-leaders-clutches-body").data("players-has-next",res.hasNextPage || 0);
        $(".table-leaders-clutches-body").data("players-next-page",res.nextPage || 0);
        
        renderClutchesTable(res);
        loading = false;
    }
    if(tab == 'bombs')
    {
        $(".table-leaders-bombs-body").data("players-page",1);
        let page = 1;
        loading = true;
        
        let res = await KTAPI.getLeaderboard({item: tab, paged: true, page, limit: 25});
        $(".table-leaders-bombs-body").data("players-total-results",res.totalDocs || 0);
        $(".table-leaders-bombs-body").data("players-total-pages",res.totalPages || 0);
        $(".table-leaders-bombs-body").data("players-has-next",res.hasNextPage || 0);
        $(".table-leaders-bombs-body").data("players-next-page",res.nextPage || 0);
        
        renderBombsTable(res);
        loading = false;
    }
    if(tab == 'maps')
    {        
        console.log("render map tab");
        if(data.subtab == null || data.subtab == '' || data.subtab == undefined)
        {
            console.log("render map tab default");

            let table = `<div class="card card-flush bg-transparent shadow-none"> 
                        <div class="card-header border-0 pt-0 px-0">                                
                            <div class="card-toolbar leaderboard-tabs-maplisthover-scroll-x">
                                <ul class="nav flex-nowrap text-nowrap" id="leaderboard-map-tabs" role="tablist">
                                                                            
                                </ul>
                            </div>
                        </div>                                            
                    </div>
                    <div class="table-responsive">
                        <!--begin::Table-->       
                        <table class="table table-custom align-middle gs-0 gy-4">
                            <!--begin::Table head-->
                            <thead>
                                <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                    <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                    <th class="" data-i18n="stats.maps">Map</th>
                                    <th class="text-nowrap" data-i18n="stats.tsp">Times Played</th>
                                    <th class="" data-i18n="stats.kills">Kills</th>
                                    <th class="" data-i18n="stats.assists">Assists</th>
                                    <th class="" data-i18n="stats.deaths">Deaths</th>
                                    <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HS / HSP</th>
                                    <th class="" data-i18n="stats.rounds">Rounds</th>
                                    <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tbp;[data-bs-original-title]stats.tbp;">BP</th>
                                    <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tbd;[data-bs-original-title]stats.tbd;">BD</th>
                                    <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tbe;[data-bs-original-title]stats.tbe;">BE</th>                                        
                                    <th class="text-nowrap rounded-end pe-4" data-i18n="stats.tp">Time Played</th>
                                </tr>
                            </thead>
                            <!--end::Table head-->
                            

                            <!--begin::Table body-->
                            <tbody class="table-maps-body">
                            </tbody>
                        </table>
                        <!--end::Table-->
                    </div>
            `;

            $("#leaderboard-tab-maps").html("").append(table).localize();
            $("#leaderboard-tab-maps").find('[data-toggle="tooltip"]').tooltip();

            let res = await KTAPI.getLeaderboard({item: tab, subitem: ''});
            if(res.message !== undefined && res.message == 'error') return;
            if(res.length == 0) return;

            let html = [];
            let tabs = [];
            let pos = 1;
            res.map(map => {
                tabs.push(renderMapTab(map));
                html.push(renderMap(map));
                pos++;
            }
            );

            $(".table-maps-body").html("").append(html).localize();
            $("#leaderboard-map-tabs").html("").append(tabs).localize();
            router.updatePageLinks();

            function renderMapTab(data)
            {
                let tab = /* html */`
                <li class="nav-item" role="presentation">
                    <a class="nav-link leaderboard-subtab btn btn-outline-light btn-color-gray-700 btn-active-light btn-active-color-primary btn-sm me-1"  data-bs-toggle="tab" data-bs-target="#who-knows" tab="${data._id}" data-navigo href="leaderboard/maps/${data._id}" aria-selected="true" tabindex="-1" role="tab">${data._id}</a>
                </li>`;
                tab = $(tab);
                return tab;
            }

            function renderMap(data)
            {
                let connectionTime = moment.duration(data.connection_time, 'seconds');
                let formattedTime = moment.utc(connectionTime.asMilliseconds()).format('HH:mm:ss');
                let t = /* html */`
                    <tr class="position-relative cursor-pointer fs-7 text-gray-800" data-navigo href="leaderboard/maps/${data._id}" style="background-color: #1b1b1b">
                        
                        <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${pos}</td>
                        <td class="text-center"><div class="position-relative w-150px h-50px overflow-hidden rounded">
                        <img src="assets/media/maps/400px/${data._id}.jpg" class="rounded" alt="" style="position: relative;top: 50%;transform: translate(-50%,-50%);left: 50%;">                                 
                        <span class="position-absolute badge badge-sm badge-light-primary bg-body bg-opacity-75 fs-small d-block" style="top: 50%;transform: translate(-50%,-50%);left: 50%;">${data._id}</span>
                        </div></td>
                        <td class="text-center">${data.count}</td>
                        <td class="text-center">${data.kills}</td>
                        <td class="text-center">${data.assists}</td>
                        <td class="text-center">${data.deaths}</td>
                        <td class="text-center text-nowrapt">${data.hs} / <span class="text-success">${(data.hs*100/(data.kills ? data.kills : 1)).toFixed(2)}%</span></td>
                        <td class="text-center">${data.rounds}</td>
                        <td class="text-center">${data.bombs_planted}</td>
                        <td class="text-center">${data.bombs_defused}</td>
                        <td class="text-center">${data.bombs_exploded}</td>
                        <td class="pe-4 text-primary text-end rounded-end">${formattedTime}</td>

                    </tr>
                `;

                t = $(t);                

                return t;
            }
        }
        else
        {

            let table = `<div class="table-responsive">
                    <!--begin::Table-->       
                    <table class="table table-custom align-middle gs-0 gy-4">
                        <!--begin::Table head-->
                        <thead>
                            <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                <th class="mw-150px" data-i18n="stats.player">Player</th>
                                <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills">K</th>
                                <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tassists;[data-bs-original-title]stats.tassists">A</th>
                                <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths">D</th>
                                <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">HS</th>
                                <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.ttks;[data-bs-original-title]stats.tkdr">KDR</th>
                                <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</th>
                                <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.tapk;[data-bs-original-title]stats.tapk">APK</th>
                                <th class="text-primary text-center" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>
                                <th class="" data-i18n="stats.tsp">Times Played</th>
                                <th class="text-success" data-i18n="stats.winrate">Win Rate</th>
                                <th class="" data-i18n="stats.rounds">Rounds</th>
                                <th class="text-success" data-toggle="tooltip" title="" data-i18n="[title]stats.trwp;[data-bs-original-title]stats.trwp">Rounds Win / RWP</th>
                                <th class="text-nowrap rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.trdif;[data-bs-original-title]stats.trdif">Rating Dif</th>
                            </tr>
                        </thead>
                        <!--end::Table head-->
                        

                        <!--begin::Table body-->
                        <tbody class="table-leaders-maps-body">
                        </tbody>
                    </table>
                    <!--end::Table-->
                </div>`;
            
            $("#leaderboard-tab-maps").html("").append(table).localize();
            $("#leaderboard-tab-maps").find('[data-toggle="tooltip"]').tooltip();

            
            $(".table-leaders-maps-body").data("players-page",1);
            let page = 1;
            loading = true;

            let res = await KTAPI.getLeaderboard({item: tab, subitem: data.subtab, paged: true, page: 1, limit: 25});
            console.log(res);

            $(".table-leaders-maps-body").data("players-page",1);
            $(".table-leaders-maps-body").data("players-total-results",res.totalDocs || 0);
            $(".table-leaders-maps-body").data("players-total-pages",res.totalPages || 0);
            $(".table-leaders-maps-body").data("players-has-next",res.hasNextPage || 0);
            $(".table-leaders-maps-body").data("players-next-page",res.nextPage || 0);

            renderMapLeaderTable(res);
            loading = false;

            
        }

    }
    if(tab == 'weapons')
    {
        if(data.subtab == null || data.subtab == '' || data.subtab == undefined)
        {            
            let table = `
            <div class="card card-flush bg-transparent shadow-none"> 
                <div class="card-header border-0 pt-0 px-0">                                
                    <div class="card-toolbar leaderboard-tabs-weaponlist hover-scroll-x">
                        <ul class="nav flex-nowrap text-nowrap" id="leaderboard-weapon-tabs" role="tablist">
                                                                    
                        </ul>
                    </div>
                </div>                                            
            </div>
            <!--begin::Table container-->
            <div class="table-responsive">
                <!--begin::Table-->
                <table class="table table-custom align-middle gs-0 gy-4">
                    <!--begin::Table head-->
                    <thead>
                        <tr class="fw-bold text-gray-600 fs-7" style="background-color: #1b1b1b">
                        <th class="ps-4 rounded-start">Pos</th>
                        <th class="text-center" data-i18n="stats.weapon">Weapon</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills">K</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths">D</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">HS</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HS%</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfk;[data-bs-original-title]stats.tfk">FK</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfd;[data-bs-original-title]stats.tfd">FD</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.twb;[data-bs-original-title]stats.twb">WB</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tqs;[data-bs-original-title]stats.tqs">QS</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tns;[data-bs-original-title]stats.tns">NS</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thits;[data-bs-original-title]stats.thits;stats.hits">Hits</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tshots;[data-bs-original-title]stats.tshots;stats.shots">Shots</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdmg;[data-bs-original-title]stats.tdmg;stats.dmg">Dmg</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.taccuracy;[data-bs-original-title]stats.taccuracy;stats.taccuracy">Acc</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thead;[data-bs-original-title]stats.thead;stats.head">Head</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tchest;[data-bs-original-title]stats.tchest;stats.chest">Chest</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tstomach;[data-bs-original-title]stats.tstomach;stats.stomach">Stomach</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlarm;[data-bs-original-title]stats.tlarm;stats.larm">Left Arm</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trarm;[data-bs-original-title]stats.trarm;stats.rarm">Right Arm</th>
                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlleg;[data-bs-original-title]stats.tlleg;stats.lleg">Left Leg</th>
                        <th class="text-nowrap rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.trleg;[data-bs-original-title]stats.trleg;stats.rleg">Right Leg</th>
                    </tr>
                    </thead>
                    <!--end::Table head-->

                    <!--begin::Table body-->
                    <tbody class="table-weapons-body">                        
                        
                    </tbody>
                    <!--end::Table body-->
                </table>
                <!--end::Table-->
            </div>
            <!--end::Table container-->`;

            $("#leaderboard-tab-weapons").html("").append(table).localize();
            $("#leaderboard-tab-weapons").find('[data-toggle="tooltip"]').tooltip();

            let res = await KTAPI.getLeaderboard({item: tab, subitem: ''});
            console.log(res);

            if(res.message !== undefined && res.message == 'error') return;
            if(res.length == 0) return;

            let html = [];
            let tabs = [];
            let pos = 1;
            
            res.map(weapon => {
                if(weapon.weapon_id == 25 || weapon.weapon_id == 6 || weapon.weapon_id == 9 )
                {}else
                {
                tabs.push(renderWeaponTab(weapon));
                html.push(renderWeapon(weapon));
                pos++;
                }
            });

            $(".table-weapons-body").html("").append(html).localize();
            $("#leaderboard-weapon-tabs").html("").append(tabs).localize();
            router.updatePageLinks();

            function renderWeaponTab(data)
            {
                let tab = /* html */`
                <li class="nav-item" role="presentation">
                    <a class="nav-link leaderboard-subtab btn btn-outline-light btn-color-gray-700 btn-active-light btn-active-color-primary btn-sm me-1"  data-bs-toggle="tab" data-bs-target="#who-knows" tab="${data.weapon}" data-navigo href="leaderboard/weapons/${data.weapon}" aria-selected="true" tabindex="-1" role="tab"><div class="text-center w-75px">
                    <img src="assets/media/weapons/colored/${data.weapon_id}.png" class="m-0 img-fluid" alt=""/>
                    </div></a>
                </li>`;
                tab = $(tab);
                return tab;
            }

            function renderWeapon(data)
            {
                let t = /* html */`
                    <tr class="position-relative cursor-pointer fs-7 text-gray-800" data-navigo href="leaderboard/weapons/${data.weapon}" style="background-color: #1b1b1b">                       

                        <td class="ps-4 rounded-start">${pos}.</td>
                        <td class="text-center" style="background: rgb(255,128,0);
                        background: radial-gradient(circle, rgba(255,128,0,0.3) 0%, rgba(255,255,255,0) 85%);">
                            <div class="d-flex flex-column">
                                <div class="text-center text-uppercase">
                                    ${data.weapon}
                                </div>
                                <div class="text-center">
                                    <img src="assets/media/weapons/colored/${data.weapon_id}.png" class="m-0" alt=""/>
                                </div>
                            </div>
                            
                        </td>
                        
                        <td class="text-center">${data.weapon_kills}</td>
                        <td class="text-center">${data.weapon_deaths}</td>
                        <td class="text-center">${data.weapon_headshots}</td>
                        <td class="text-center">${(data.weapon_headshots*100/(data.weapon_kills == 0 ? 1 : data.weapon_kills)).toFixed(2)}%</td>
                        <td class="text-center">${data.weapon_fk}</td>
                        <td class="text-center">${data.weapon_fd}</td>
                        <td class="text-center">${data.weapon_wb}</td>
                        <td class="text-center">${data.weapon_qs}</td>
                        <td class="text-center">${data.weapon_ns}</td>
                        <td class="text-center">${data.weapon_hits}</td>
                        <td class="text-center">${data.weapon_shots}</td>
                        <td class="text-center">${data.weapon_damage}</td>                    
                        <td class="text-center">${(data.weapon_hits*100/(data.weapon_shots == 0 ? 1 : data.weapon_shots)).toFixed(2)}%</td>
                        <td class="text-center">${data.hit_head}</td>
                        <td class="text-center">${data.hit_chest}</td>
                        <td class="text-center">${data.hit_stomach}</td>
                        <td class="text-center">${data.hit_leftarm}</td>
                        <td class="text-center">${data.hit_rightarm}</td>
                        <td class="text-center">${data.hit_leftleg}</td>
                        <td class="text-center pe-4 rounded-end">${data.hit_rightleg}</td>
                    </tr>
                `;

                t = $(t);                

                return t;
            }
        }
        else
        {
            let table = `<div class="table-responsive">
                <!--begin::Table-->       
                <table class="table table-custom align-middle gs-0 gy-4">
                    <!--begin::Table head-->
                    <thead>
                        <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                            <th class="ps-4 rounded-start min-w-75px">Pos</th>
                            <th class="mw-150px">Player</th>                            
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tkills;[data-bs-original-title]stats.tkills">K</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdeaths;[data-bs-original-title]stats.tdeaths">D</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">HS</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HS%</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfk;[data-bs-original-title]stats.tfk">FK</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tfd;[data-bs-original-title]stats.tfd;">FD</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.twb;[data-bs-original-title]stats.twb;">WB</th>
                            ${data.subtab == 'awp' || data.subtab == 'scout' ? '<th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tqs;[data-bs-original-title]stats.tqs;">QS</th><th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tns;[data-bs-original-title]stats.tns;">NS</th>' : ''}
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thits;[data-bs-original-title]stats.thits;stats.hits">Hits</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tshots;[data-bs-original-title]stats.tshots;stats.shots">Shots</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tdamage;[data-bs-original-title]stats.tdamage;stats.damage">Dmg</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.taccuracy;[data-bs-original-title]stats.taccuracy;stats.accuracy">Acc</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.thead;[data-bs-original-title]stats.thead;stats.head">Head</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tchest;[data-bs-original-title]stats.tchest;stats.chest">Chest</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tstomach;[data-bs-original-title]stats.tstomach;stats.stomach">Stomach</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlarm;[data-bs-original-title]stats.tlarm;stats.larm">Left Arm</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.trarm;[data-bs-original-title]stats.trarm;stats.rarm">Right Arm</th>
                            <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tlleg;[data-bs-original-title]stats.tlleg;stats.lleg">Left Leg</th>
                            <th class="text-nowrap text-end rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.trleg;[data-bs-original-title]stats.trleg;stats.rleg">Right Leg</th>
                        </tr>
                    </thead>
                    <!--end::Table head-->
                    

                    <!--begin::Table body-->
                    <tbody class="table-leaders-weapons-body">
                    </tbody>
                </table>
                <!--end::Table-->
            </div>`;

            $("#leaderboard-tab-weapons").html("").append(table).localize();
            $("#leaderboard-tab-weapons").find('[data-toggle="tooltip"]').tooltip();

            $(".table-leaders-weapons-body").data("players-page",1);
            let page = 1;
            loading = true;

            let res = await KTAPI.getLeaderboard({item: tab, subitem: data.subtab, paged: true, page: 1, limit: 25});
            console.log(res);

            $(".table-leaders-weapons-body").data("players-page",1);
            $(".table-leaders-weapons-body").data("players-total-results",res.totalDocs || 0);
            $(".table-leaders-weapons-body").data("players-total-pages",res.totalPages || 0);
            $(".table-leaders-weapons-body").data("players-has-next",res.hasNextPage || 0);
            $(".table-leaders-weapons-body").data("players-next-page",res.nextPage || 0);

            renderWeaponLeaderTable(res);
            loading = false;

        }
    }
};

const renderWeaponLeaderTable = (res) => {
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    }
    );

    $(".table-leaders-weapons-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">

                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">

                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>

                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.countrycode !== undefined ? data.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.weapon_kills}</td>
                <td>${data.weapon_deaths}</td>
                <td>${data.weapon_headshots}</td>
                <td>${(data.weapon_headshots*100/(data.weapon_kills == 0 ? 1 : data.weapon_kills)).toFixed(2)}%</td>
                <td>${data.weapon_fk}</td>
                <td>${data.weapon_fd}</td>
                <td>${data.weapon_wb}</td>
                ${data.subtab == 'awp' || data.subtab == 'scout' ? '<td>'+data.weapon_qs+'</td><td>'+data.weapon_ns+'</td>' : ''}
                <td>${data.weapon_hits}</td>
                <td>${data.weapon_shots}</td>
                <td>${data.weapon_damage}</td>
                <td>${(data.weapon_hits*100/(data.weapon_shots == 0 ? 1 : data.weapon_shots)).toFixed(2)}%</td>
                <td>${data.hit_head}</td>
                <td>${data.hit_chest}</td>
                <td>${data.hit_stomach}</td>
                <td>${data.hit_leftarm}</td>
                <td>${data.hit_rightarm}</td>
                <td>${data.hit_leftleg}</td>
                <td class="rounded-end pe-4">${data.hit_rightleg}</td>
            </tr>
        `;
        t = $(t);
        t.find(".pl-nick").text(data.nickname !== undefined ? data.nickname : '');

        return t;
    }
}

function renderMapLeaderTable(res)
{
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    });

    $(".table-leaders-maps-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">

                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            

                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>

                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.countrycode !== undefined ? data.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.kills}</td>
                <td>${data.assists}</td>
                <td>${data.deaths}</td>
                <td>${data.hs}</td>
                <td>${(data.kills/(data.deaths ? data.deaths : 1)).toFixed(2)}</td>
                <td>${(data.kills/(data.rounds ? data.rounds : 1)).toFixed(2)}</td>
                <td>${(data.assists/(data.rounds ? data.rounds : 1)).toFixed(2)}</td>
                <td>${(data.hs*100/(data.kills ? data.kills : 1)).toFixed(2)}%</td>
                <td>${data.count}</td>
                <td>${(data.wins*100/(data.count ? data.count : 1)).toFixed(2)}%</td>
                <td>${data.rounds}</td>
                <td>${data.rounds_win} / ${(data.rounds_win*100/(data.rounds ? data.rounds : 1)).toFixed(2)}%</td>
                <td class="rounded-end pe-4">${data.difrating.toFixed(2)}</td>
            </tr>
        `;
        t = $(t);
        t.find(".pl-nick").text(data.nickname !== undefined ? data.nickname : '');
        
        return t;
    }
}

function renderKillsTable(res)
{
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    }
    );

    $(".table-leaders-kills-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        //console.log(data);
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            
                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.profile.avatar === undefined ? "assets/media/avatars/default.jpg" : data.profile.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.profile.countrycode !== undefined ? data.profile.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.profile.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.kills}</td>
                <td>${data.assists}</td>
                <td>${data.deaths}</td>
                <td>${data.hs}</td>
                <td>${(data.kills/(data.deaths ? data.deaths : 1)).toFixed(2)}</td>
                <td>${(data.kills/(data.rounds ? data.rounds : 1)).toFixed(2)}</td>
                <td>${(data.assists/(data.rounds ? data.rounds : 1)).toFixed(2)}</td>
                <td class="rounded-end pe-4">${(data.hs*100/(data.kills ? data.kills : 1)).toFixed(2)}%</td>
            </tr>`;

            t = $(t);
            t.find(".pl-nick").text(data.profile.nickname !== undefined ? data.profile.nickname : '');
    
            return t;

    }

    
}

function renderAimTable(res)
{

    let html = [];    
    if(res.message == 'error') return;
    let pos = 1;
    
    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    });

    $(".table-leaders-aim-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            
                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.profile.avatar === undefined ? "assets/media/avatars/default.jpg" : data.profile.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.profile.countrycode !== undefined ? data.profile.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.profile.steamid}</a>
                        </div>
                    </div>
                </td>                        
                <td>${data.hits}</td>
                <td>${data.shots}</td>
                <td>${data.damage}</td>
                <td>${data.hb_head}</td>
                <td>${data.hb_chest}</td>
                <td>${data.hb_stomach}</td>
                <td>${data.hb_leftarm}</td>
                <td>${data.hb_rightarm}</td>
                <td>${data.hb_leftleg}</td>
                <td>${data.hb_rightleg}</td>
                <td>${((data.hits/(data.shots ? data.shots : 1))*100).toFixed(2)}%</td>
                <td>${(data.damage/(data.rounds ? data.rounds : 1)).toFixed(2)}</td>
                <td class="text-danger pe-4 rounded-end">${(data.shots/(data.kills ? data.kills : 1)).toFixed(2)}</td>
                
            </tr>            
        `;

        t = $(t);
        t.find(".pl-nick").text(data.profile.nickname !== undefined ? data.profile.nickname : '');

        return t;
    }
}

function rendermultikillsTable(res)
{
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    }
    );

    $(".table-leaders-multikills-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            
                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.profile.avatar === undefined ? "assets/media/avatars/default.jpg" : data.profile.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.profile.countrycode !== undefined ? data.profile.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.profile.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.k5}</td>
                <td>${data.k4}</td>
                <td>${data.k3}</td>
                <td>${data.k2}</td>
                <td>${data.total}</td>
                <td class="text-danger pe-4 rounded-end">${(data.total/(data.matches ? data.matches : 1)).toFixed(2)}</td>
            </tr>
        `;
        t = $(t);
        t.find(".pl-nick").text(data.profile.nickname !== undefined ? data.profile.nickname : '');

        return t;
            
    }
}

function renderClutchesTable(res)
{
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    }
    );

    $(".table-leaders-clutches-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            
                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.profile.avatar === undefined ? "assets/media/avatars/default.jpg" : data.profile.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.profile.countrycode !== undefined ? data.profile.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.profile.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.v5}</td>
                <td>${data.v4}</td>
                <td>${data.v3}</td>
                <td>${data.v2}</td>
                <td>${data.v1}</td>
                <td>${data.total}</td>
                <td class="text-danger pe-4 rounded-end">${(data.total/(data.matches ? data.matches : 1)).toFixed(2)}</td>
            </tr>
        `;
        t = $(t);
        t.find(".pl-nick").text(data.profile.nickname !== undefined ? data.profile.nickname : '');

        return t;
            
    }
}

function renderBombsTable(res)
{
    let html = [];
    if(res.message == 'error') return;
    let pos = 1;

    res.docs.map(pl => {
        html.push(renderPlayer(pl));
        pos++;
    }
    );

    $(".table-leaders-bombs-body").append(html);
    router.updatePageLinks();

    function renderPlayer(data)
    {
        let t = /* html */`
            <tr class="position-relative cursor-pointer fs-7 ${(res.page-1)*(res.limit)+pos < 4 ? 'top-rank' : ''}" data-navigo href="user/${data.communityid}" style="background-color: #1b1b1b">
                
                <td class="text-center position-relative z-index-2 ps-4 rounded-start text-nowrap">${(res.page-1)*(res.limit)+pos < 4 ? `<i class="fad fa-trophy-alt top-trophy-${(res.page-1)*(res.limit)+pos} fs-1 me-2"></i>`: ''}${(res.page-1)*(res.limit)+pos}.</td>
                <td class="position-relative z-index-2">                            
                    
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-50px me-5 rounded overflow-hidden">
                            <span class="symbol-label bg-light">
                                <img src="${data.profile.avatar === undefined ? "assets/media/avatars/default.jpg" : data.profile.avatar}" class="h-100 align-self-end" alt="">
                            </span>
                        </div>
                        
                        <div class="d-flex justify-content-start flex-column">
                            <div class="d-flex align-items-center"> <img class="me-2" src="assets/media/flags/${data.profile.countrycode !== undefined ? data.profile.countrycode.toLowerCase() : data.flag.toLowerCase()}.gif"/> <a href="user/${data.profile.communityid}" data-navigo class="text-dark fw-bold text-hover-primary mb-1 fs-6 pl-nick text-nowrap text-truncate mw-125px"></a></div>
                            <a href="https://steamcommunity.com/profiles/${data.profile.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 text-nowrap text-truncate mw-125px">${data.profile.steamid}</a>
                        </div>
                    </div>
                </td>
                <td>${data.bombs_planted}</td>
                <td>${data.bombs_defused}</td>
                <td>${data.bombs_exploded}</td>
                <td>${data.bombsite_a}</td>
                <td>${data.bombsite_b}</td>
                <td>${((data.bombs_planted/(data.matches ? data.matches : 1)).toFixed(2))}</td>
                <td>${((data.bombs_defused/(data.matches ? data.matches : 1)).toFixed(2))}</td>
                <td class="text-danger pe-4 rounded-end">${(data.bombs_exploded/(data.bombs_planted ? data.bombs_planted : 1)).toFixed(2)}</td>
            </tr>
        `;
        t = $(t);
        t.find(".pl-nick").text(data.profile.nickname !== undefined ? data.profile.nickname : '');

        return t;
            
    }
}

const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
};



export default players;